import AppSidebar from './AppSidebar';
import { Navbar } from './common/Catalyst/navbar';
import { SidebarLayout } from './common/Catalyst/sidebar-layout';
import CommunicationListComponent from './communication/CommunicationListComponent';

interface CommunicationPageProps {
  currentPage: string;
}

const CommunicationPage: React.FC<CommunicationPageProps> = ({
  currentPage,
}) => {
  return (
    <SidebarLayout
      sidebar={<AppSidebar currentPage={currentPage} />}
      navbar={<Navbar>{/* Your navbar content */}</Navbar>}
      // The list uses the whole panel and scrolls inside itself, with its
      // filter bar as the top row, like violations and work orders.
      fill
      flush
    >
      {/* No page heading: the sidebar already says where you are. */}
      <CommunicationListComponent />
    </SidebarLayout>
  );
};

export default CommunicationPage;
